import { isAxiosError } from 'axios'

import { parseServerDate } from '@/utils/dates'
import { isProductionEnvironment } from '@/utils/sponsors'

// The backend's push_notifications limits (validate_message, image_upload_max_mb).
export const TITLE_MAX_LENGTH = 65
export const BODY_MAX_LENGTH = 240
export const IMAGE_MAX_BYTES = 20 * 1024 * 1024
export const IMAGE_MIME_TYPES = ['image/png', 'image/jpeg']

export const HISTORY_PAGE_SIZE = 10

// SME-1159: off on prod until the app release that receives channel pushes is out.
export const NOTIFICATIONS_ENABLED_ON_PROD = false

export function notificationsEnabled() {
  return NOTIFICATIONS_ENABLED_ON_PROD || !isProductionEnvironment()
}

/** "Short name: ", falling back to the long name. Counts toward TITLE_MAX_LENGTH. */
export function titlePrefix(names: { sponsorNameShort?: string | null; sponsorName?: string | null } | undefined) {
  const name = names?.sponsorNameShort?.trim() || names?.sponsorName?.trim()
  return name ? `${name}: ` : ''
}

export function isDuplicateSendError(error: unknown) {
  return (
    isAxiosError(error) &&
    error.response?.status === 409 &&
    error.response.data?.detail?.error_code === 'DUPLICATE_PUSH_NOTIFICATION'
  )
}

export function sendErrorMessage(error: unknown) {
  const detail = isAxiosError(error) ? error.response?.data?.detail : undefined
  return typeof detail === 'string' && detail ? detail : 'The notification could not be sent. Please try again.'
}

/** The send time in the viewer's timezone, with the zone shown ("Oct 20, 2026 6:05 PM PDT"). */
export function formatSentAt(sentAt: string) {
  const sent = parseServerDate(sentAt)
  if (!sent.isValid()) return ''
  // Built per call: a formatter fixes the zone it was created in, which goes stale if the viewer's zone changes.
  const zone = new Intl.DateTimeFormat('en-US', { timeZoneName: 'short' })
    .formatToParts(sent.toDate())
    .find(part => part.type === 'timeZoneName')?.value
  return [sent.format('MMM D, YYYY h:mm A'), zone].filter(Boolean).join(' ')
}
